<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dbWcpG/media/FC-9781035834839.jpg?1721600811829" alt="This image is the cover for the book The Document"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Document
      </h1>
      <p class="bookDescription body article font2">
        <p>They say that everybody has a book in them. When I embarked on my retirement journey, I decided to discover mine, resulting in this, my debut novel. Amidst the ancient stones of Stonehenge, on the dawn of the new millennium’s first summer solstice, Christopher’s day takes an unexpected turn. A stray piece of paper, carried by the morning breeze, finds its way to him. But it’s not just the paper that captures his attention—it’s the captivating stranger who appears just as mysteriously. Together, they unravel the cryptic foreign writings on the paper, diving deep into a puzzle that leads them on a quest for understanding. Is the document they’ve stumbled upon a profound revelation or just an elaborate ruse? Join Christopher and his newfound companion as they journey to decode The Document, and in the process, discover more than they ever anticipated.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alice V Todd
      </h2>
      
      <p class="authorDescription body article">I was told, “everyone has a book in them”; when I retired, I tried out that statement. I enjoyed doing it and have had my first book published. This has given me a great sense of satisfaction. Having created a cast of characters, I aim to use them in future stories.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?638126ee